import { Component, OnInit } from '@angular/core';

import { CommonModule } from '@angular/common';
import { CommonService } from '../../services/common-service';
import { CustomMatIconService } from '../../services/mat-icons-service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { ProfileIconComponent } from '../../layout/profile-icon/profile-icon.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from '../../layout/sidebar/sidebar.component';
import { TopbarComponent } from '../../layout/topbar/topbar.component';

@Component({
  selector: 'app-home-dashboard',
  imports: [RouterModule, CommonModule, ReactiveFormsModule, SidebarComponent,ProfileIconComponent],
  standalone: true,
  templateUrl: './home-dashboard.component.html',
  styleUrl: './home-dashboard.component.scss'
})
export class HomeDashboardComponent implements OnInit {
  constructor(public commonService: CommonService,
    public matIconRegistry: MatIconRegistry,
    public domSanitizer: DomSanitizer,
    public customMatIconService: CustomMatIconService
  ) {

  }
  ngOnInit(): void {

  }
  isMobile(): boolean {
    return window.innerWidth <= 991; // adjust breakpoint as needed (e.g., 768 for tablets)
  }
}
